// src/Components/Login.jsx
import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
// import { login } from '../services/api'; // Comment out for mock login

const Login = ({ onLogin }) => {
  const [credentials, setCredentials] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  
  const navigate = useNavigate();
  const location = useLocation();
  const redirectPath = location.state?.redirect || '/';
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCredentials({
      ...credentials,
      [name]: value
    });
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);
    
    try {
      // Mock successful login
      const userData = {
        user: {
          id: 2,
          name: 'Admin User',
          email: 'admin@example.com',
          avatar: '/api/placeholder/40/40'
        },
        token: 'mock-token'
      };
      
      // Store in localStorage as your API service would
      localStorage.setItem('token', userData.token);
      localStorage.setItem('user', JSON.stringify(userData.user));
      
      // Call the onLogin callback
      onLogin(userData.user);
      
      // Navigate to the redirect path
      navigate(redirectPath);
      
      // Real API call (commented out for now)
      // const userData = await login(credentials);
      // onLogin(userData.user);
      // navigate(redirectPath);
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed. Please check your credentials.');
    } finally {
      setIsLoading(false);
    }
  };
  
  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>Login to Your Account</h2>
        <p className="auth-subtitle">Access your NFT collection and make purchases</p>
        
        {error && <div className="auth-error">{error}</div>}
        
        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={credentials.email}
              onChange={handleInputChange}
              required
              placeholder="your@email.com"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={credentials.password}
              onChange={handleInputChange}
              required
              placeholder="••••••••"
            />
          </div>
          
          <button 
            type="submit" 
            className="auth-button"
            disabled={isLoading}
          >
            {isLoading ? 'Logging in...' : 'Login'}
          </button>
        </form>
        
        <div className="auth-footer">
          <p>Don't have an account? <Link to="/register" className="auth-link">Sign up</Link></p>
        </div>
      </div>
      
      <div className="auth-info">
        <h3>Why create an account?</h3>
        <ul>
          <li>Purchase NFTs with credit card</li>
          <li>No crypto wallet required</li>
          <li>Track all your digital assets</li>
          <li>Secure ownership on the blockchain</li>
        </ul>
      </div>
    </div>
  );
};

export default Login;